import * as actionTypes from '../actions/actionsTypes';

const initialState = {
  data: []
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_GROUP_DATA:
      return {
        ...state,
        data: [...action.data]
      }
    default:
      return state;
  }
}

export default reducer;